import React from 'react';

const SESSION_KEY = 'ftb_unlocked';
const PASSWORD = process.env.REACT_APP_PREVIEW_PASSWORD || 'fortheboys';

interface Props {
  children: React.ReactNode;
}

const PasswordGate: React.FC<Props> = ({ children }) => {
  const [unlocked, setUnlocked] = React.useState(
    () => sessionStorage.getItem(SESSION_KEY) === '1'
  );
  const [input, setInput] = React.useState('');
  const [error, setError] = React.useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input === PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, '1');
      setUnlocked(true);
    } else {
      setError(true);
      setInput('');
    }
  };

  if (unlocked) return <>{children}</>;

  return (
    <div className="gate-wrapper">
      <div className="gate-box">
        <h1 className="graffiti-tag gate-title">FOR THE BOYS</h1>
        <p className="gate-subtitle">Diese Seite ist noch nicht öffentlich.</p>
        <form onSubmit={handleSubmit} className="gate-form">
          <input
            type="password"
            placeholder="Passwort"
            value={input}
            onChange={(e) => { setInput(e.target.value); setError(false); }}
            className={error ? 'form-input-error' : ''}
            autoFocus
          />
          {error && <p className="form-error">Falsches Passwort.</p>}
          <button type="submit" className="submit-button" style={{ marginTop: '0.75rem', width: '100%' }}>
            Einloggen
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordGate;
